'use client';

import { BlogContactPage } from '@/components/pages/blog/BlogContactPage';
import { useAppNavigate } from '../_lib/useAppNavigate';

export default function BlogContactClient() {
  const navigate = useAppNavigate();
  return <BlogContactPage onNavigate={navigate} />;
}
